export const HandCoins = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M14.3438 7.875C15.4311 7.875 16.3125 6.99356 16.3125 5.90625C16.3125 4.81894 15.4311 3.9375 14.3438 3.9375C13.2564 3.9375 12.375 4.81894 12.375 5.90625C12.375 6.99356 13.2564 7.875 14.3438 7.875Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.375 14.625H1.125C0.975816 14.625 0.832742 14.5657 0.727252 14.4602C0.621763 14.3548 0.5625 14.2117 0.5625 14.0625V11.25C0.5625 11.1008 0.621763 10.9577 0.727252 10.8523C0.832742 10.7468 0.975816 10.6875 1.125 10.6875H3.375"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.875 11.25H10.125L14.8359 10.1665C15.0091 10.119 15.1909 10.1121 15.3672 10.1464C15.5435 10.1806 15.7096 10.255 15.8524 10.3639C15.9953 10.4727 16.1111 10.613 16.1909 10.7739C16.2707 10.9348 16.3123 11.1119 16.3125 11.2915C16.3126 11.5083 16.2522 11.7209 16.1382 11.9053C16.0242 12.0898 15.861 12.2388 15.667 12.3356L12.9375 13.5L8.4375 14.625H3.375V10.6875L5.13281 8.92969C5.28993 8.77312 5.47637 8.64906 5.68147 8.56461C5.88657 8.48015 6.10632 8.43696 6.32812 8.43751H9.84375C10.2167 8.43751 10.5744 8.58566 10.8381 8.84939C11.1018 9.11311 11.25 9.47079 11.25 9.84376C11.25 10.2167 11.1018 10.5744 10.8381 10.8381C10.5744 11.1018 10.2167 11.25 9.84375 11.25H7.875Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3749 5.99654C11.9928 6.17725 11.5627 6.23019 11.1482 6.14753C10.7337 6.06487 10.3568 5.851 10.0732 5.53754C9.78964 5.22408 9.61449 4.82768 9.57366 4.40698C9.53283 3.98627 9.62848 3.56359 9.84647 3.20146C10.0645 2.83932 10.3932 2.55696 10.7841 2.39613C11.175 2.2353 11.6073 2.20455 12.017 2.30841C12.4267 2.41228 12.7921 2.64525 13.0592 2.97288C13.3263 3.3005 13.4808 3.70538 13.4999 4.12763"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Cards = ({ width = 18, height = 18, fillColor = "#1640C1" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.9375 5.625H2.8125C2.50184 5.625 2.25 5.87684 2.25 6.1875V14.0625C2.25 14.3732 2.50184 14.625 2.8125 14.625H12.9375C13.2482 14.625 13.5 14.3732 13.5 14.0625V6.1875C13.5 5.87684 13.2482 5.625 12.9375 5.625Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 3.375H15.1875C15.3367 3.375 15.4798 3.43426 15.5852 3.53975C15.6907 3.64524 15.75 3.78832 15.75 3.9375V12.375"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShieldPlus = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.75 9H11.25"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 6.75V11.25"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1875 7.875V3.9375C15.1875 3.78832 15.1282 3.64524 15.0227 3.53975C14.9173 3.43426 14.7742 3.375 14.625 3.375H3.375C3.22582 3.375 3.08274 3.43426 2.97725 3.53975C2.87176 3.64524 2.8125 3.78832 2.8125 3.9375V7.875C2.8125 14.625 9 16.3125 9 16.3125C9 16.3125 15.1875 14.625 15.1875 7.875Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShieldCheck = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.1875 7.875V3.9375C15.1875 3.78832 15.1282 3.64524 15.0227 3.53975C14.9173 3.43426 14.7742 3.375 14.625 3.375H3.375C3.22582 3.375 3.08274 3.43426 2.97725 3.53975C2.87176 3.64524 2.8125 3.78832 2.8125 3.9375V7.875C2.8125 14.625 9 16.3125 9 16.3125C9 16.3125 15.1875 14.625 15.1875 7.875Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.1875 9.5625L7.875 11.25L11.8125 7.3125"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CurrencyBtc = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M5.0625 3.375H6.1875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.0625 14.0625H6.1875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.875 3.375V1.6875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.125 3.375V1.6875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.875 15.75V14.0625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.125 15.75V14.0625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.1875 8.4375H11.25C11.9959 8.4375 12.7113 8.73382 13.2387 9.26126C13.7662 9.78871 14.0625 10.5041 14.0625 11.25C14.0625 11.9959 13.7662 12.7113 13.2387 13.2387C12.7113 13.7662 11.9959 14.0625 11.25 14.0625H6.1875V3.375H10.4062C11.0776 3.375 11.7214 3.64168 12.1961 4.11639C12.6708 4.59109 12.9375 5.23492 12.9375 5.90625C12.9375 6.57758 12.6708 7.22141 12.1961 7.69611C11.7214 8.17082 11.0776 8.4375 10.4062 8.4375"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Money = ({ width = 18, height = 18, fillColor = "#1640C1" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.875 4.5H1.125V13.5H16.875V4.5Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.875 7.3125C16.1724 7.19341 15.5242 6.85871 15.0202 6.35478C14.5163 5.85085 14.1816 5.20264 14.0625 4.5"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0625 13.5C14.1816 12.7974 14.5163 12.1492 15.0202 11.6452C15.5242 11.1413 16.1724 10.8066 16.875 10.6875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.125 10.6875C1.82764 10.8066 2.47585 11.1413 2.97978 11.6452C3.48371 12.1492 3.81841 12.7974 3.9375 13.5"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.9375 4.5C3.81841 5.20264 3.48371 5.85085 2.97978 6.35478C2.47585 6.85871 1.82764 7.19341 1.125 7.3125"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BuildingApartent = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.125 15.1875H16.875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.75 15.1875V5.0625H12.375V2.8125H5.625V7.3125H2.25V15.1875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.4375 5.0625H9.5625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.4375 7.3125H9.5625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.375 7.3125H13.5"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 9.5625H5.625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 11.8125H5.625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.4375 9.5625H9.5625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.375 9.5625H13.5"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.375 11.8125H13.5"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.875 15.1875V11.8125H10.125V15.1875"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CoinVertical = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.3125 15.75C9.48712 15.75 11.25 12.7279 11.25 9C11.25 5.27208 9.48712 2.25 7.3125 2.25C5.13788 2.25 3.375 5.27208 3.375 9C3.375 12.7279 5.13788 15.75 7.3125 15.75Z"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.3125 2.25H10.6875C12.8623 2.25 14.625 5.27344 14.625 9C14.625 12.7266 12.8623 15.75 10.6875 15.75H7.3125"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2473 4.5H13.6223"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 9H14.625"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2473 13.5H13.6223"
        stroke={fillColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Calender = ({ width = 14, height = 15 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.375 2.57812H2.625C2.38338 2.57812 2.1875 2.774 2.1875 3.01562V11.7656C2.1875 12.0072 2.38338 12.2031 2.625 12.2031H11.375C11.6166 12.2031 11.8125 12.0072 11.8125 11.7656V3.01562C11.8125 2.774 11.6166 2.57812 11.375 2.57812Z"
        stroke="#E1E1E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.625 1.70312V3.45312"
        stroke="#E1E1E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.375 1.70312V3.45312"
        stroke="#E1E1E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.1875 5.20312H11.8125"
        stroke="#E1E1E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.03125 8.70312L6.34375 10.0156L8.96875 7.39062"
        stroke="#E1E1E1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EventLocation = ({
  width = 14,
  height = 15,
  strokeColor = "#E1E1E1",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 7.82812C7.9665 7.82812 8.75 7.04462 8.75 6.07812C8.75 5.11163 7.9665 4.32812 7 4.32812C6.0335 4.32812 5.25 5.11163 5.25 6.07812C5.25 7.04462 6.0335 7.82812 7 7.82812Z"
        stroke={strokeColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.375 6.07812C11.375 10.0156 7 13.0781 7 13.0781C7 13.0781 2.625 10.0156 2.625 6.07812C2.625 4.9178 3.08594 3.805 3.90641 2.98453C4.72688 2.16406 5.83968 1.70313 7 1.70312C8.16032 1.70313 9.27312 2.16406 10.0936 2.98453C10.9141 3.805 11.375 4.9178 11.375 6.07812Z"
        stroke={strokeColor}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const KnowMore = ({ width = 17, height = 18 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0.875C6.89303 0.875 5.32214 1.35152 3.986 2.24431C2.64985 3.1371 1.60844 4.40605 0.993482 5.8907C0.37852 7.37535 0.217618 9.00901 0.531123 10.5851C0.844628 12.1612 1.61846 13.6089 2.75476 14.7452C3.89106 15.8815 5.3388 16.6554 6.9149 16.9689C8.49099 17.2824 10.1247 17.1215 11.6093 16.5065C13.094 15.8916 14.3629 14.8502 15.2557 13.514C16.1485 12.1779 16.625 10.607 16.625 9C16.6227 6.84581 15.766 4.78051 14.2427 3.25727C12.7195 1.73403 10.6542 0.877275 8.5 0.875ZM8.5 15.875C7.14026 15.875 5.81105 15.4718 4.68046 14.7164C3.54987 13.9609 2.66868 12.8872 2.14833 11.6309C1.62798 10.3747 1.49183 8.99237 1.7571 7.65875C2.02238 6.32513 2.67716 5.10013 3.63864 4.13864C4.60013 3.17716 5.82514 2.52237 7.15876 2.2571C8.49238 1.99183 9.87471 2.12798 11.131 2.64833C12.3872 3.16868 13.4609 4.04987 14.2164 5.18045C14.9718 6.31104 15.375 7.64025 15.375 9C15.3729 10.8227 14.6479 12.5702 13.3591 13.8591C12.0702 15.1479 10.3227 15.8729 8.5 15.875ZM9.75 12.75C9.75 12.9158 9.68416 13.0747 9.56695 13.1919C9.44974 13.3092 9.29076 13.375 9.125 13.375C8.79348 13.375 8.47554 13.2433 8.24112 13.0089C8.0067 12.7745 7.875 12.4565 7.875 12.125V9C7.70924 9 7.55027 8.93415 7.43306 8.81694C7.31585 8.69973 7.25 8.54076 7.25 8.375C7.25 8.20924 7.31585 8.05027 7.43306 7.93306C7.55027 7.81585 7.70924 7.75 7.875 7.75C8.20652 7.75 8.52447 7.8817 8.75889 8.11612C8.99331 8.35054 9.125 8.66848 9.125 9V12.125C9.29076 12.125 9.44974 12.1908 9.56695 12.3081C9.68416 12.4253 9.75 12.5842 9.75 12.75ZM7.25 5.5625C7.25 5.37708 7.30499 5.19582 7.408 5.04165C7.51101 4.88748 7.65743 4.76732 7.82874 4.69636C8.00004 4.62541 8.18854 4.60684 8.3704 4.64301C8.55226 4.67919 8.7193 4.76848 8.85042 4.89959C8.98153 5.0307 9.07082 5.19775 9.10699 5.3796C9.14316 5.56146 9.1246 5.74996 9.05364 5.92127C8.98268 6.09257 8.86252 6.23899 8.70835 6.342C8.55418 6.44502 8.37292 6.5 8.1875 6.5C7.93886 6.5 7.70041 6.40123 7.52459 6.22541C7.34878 6.0496 7.25 5.81114 7.25 5.5625Z"
        fill="#EBEBEB"
      />
    </svg>
  );
};

export const RupeesIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4497 21L6 14.154V11.8633H9.97409C11.3033 11.8633 12.2912 11.5857 12.9378 11.0304C13.5934 10.4751 13.9212 9.66377 13.9212 8.59653V8.5705C13.9212 7.46855 13.5934 6.64859 12.9378 6.11063C12.2912 5.57267 11.3033 5.30369 9.97409 5.30369H6V3.49458H10.742C12.0352 3.49458 13.1399 3.69414 14.056 4.09328C14.981 4.48373 15.6905 5.06508 16.1845 5.83731C16.6874 6.60087 16.9389 7.54664 16.9389 8.67462V8.70065C16.9389 9.81128 16.6874 10.7744 16.1845 11.59C15.6905 12.397 14.972 13.0217 14.029 13.4642C13.095 13.9067 11.9589 14.128 10.6207 14.128H8.62694L9.11192 13.4121L17.4642 21H13.4497ZM6 9.31236V7.84165H19V9.31236H6ZM6 4.50976V3H19V4.50976H6Z"
        fill="url(#paint0_linear_205_97774)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_205_97774"
          x1="12.5"
          y1="3"
          x2="12.5"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Ticket = ({ width = 25, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.25 9.75C22.4489 9.75 22.6397 9.67098 22.7803 9.53033C22.921 9.38968 23 9.19891 23 9V6C23 5.60218 22.842 5.22064 22.5607 4.93934C22.2794 4.65804 21.8978 4.5 21.5 4.5H3.5C3.10218 4.5 2.72064 4.65804 2.43934 4.93934C2.15804 5.22064 2 5.60218 2 6V9C2 9.19891 2.07902 9.38968 2.21967 9.53033C2.36032 9.67098 2.55109 9.75 2.75 9.75C3.34674 9.75 3.91903 9.98705 4.34099 10.409C4.76295 10.831 5 11.4033 5 12C5 12.5967 4.76295 13.169 4.34099 13.591C3.91903 14.0129 3.34674 14.25 2.75 14.25C2.55109 14.25 2.36032 14.329 2.21967 14.4697C2.07902 14.6103 2 14.8011 2 15V18C2 18.3978 2.15804 18.7794 2.43934 19.0607C2.72064 19.342 3.10218 19.5 3.5 19.5H21.5C21.8978 19.5 22.2794 19.342 22.5607 19.0607C22.842 18.7794 23 18.3978 23 18V15C23 14.8011 22.921 14.6103 22.7803 14.4697C22.6397 14.329 22.4489 14.25 22.25 14.25C21.6533 14.25 21.081 14.0129 20.659 13.591C20.2371 13.169 20 12.5967 20 12C20 11.4033 20.2371 10.831 20.659 10.409C21.081 9.98705 21.6533 9.75 22.25 9.75ZM3.5 15.675C4.34772 15.5029 5.10986 15.043 5.65728 14.3732C6.20471 13.7034 6.50376 12.865 6.50376 12C6.50376 11.135 6.20471 10.2966 5.65728 9.62681C5.10986 8.95705 4.34772 8.49714 3.5 8.325V6H8.75V18H3.5V15.675ZM21.5 15.675V18H10.25V6H21.5V8.325C20.6523 8.49714 19.8901 8.95705 19.3427 9.62681C18.7953 10.2966 18.4962 11.135 18.4962 12C18.4962 12.865 18.7953 13.7034 19.3427 14.3732C19.8901 15.043 20.6523 15.5029 21.5 15.675Z"
        fill="url(#paint0_linear_1693_86903)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1693_86903"
          x1="12.5"
          y1="4.5"
          x2="12.5"
          y2="19.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
          <stop offset="1" stop-color="#D8B65A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Clock = ({ width = 25, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
        stroke="url(#paint0_linear_205_97770)"
        stroke-width="1.5"
      />
      <path
        d="M12.5 8V12L15 14.5"
        stroke="url(#paint1_linear_205_97770)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_205_97770"
          x1="12.5"
          y1="2"
          x2="12.5"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_205_97770"
          x1="13.75"
          y1="8"
          x2="13.75"
          y2="14.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CalenderMinimal = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z"
        stroke="url(#paint0_linear_205_97767)"
        stroke-width="1.5"
      />
      <path
        d="M7 4V2.5"
        stroke="url(#paint1_linear_205_97767)"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M17 4V2.5"
        stroke="url(#paint2_linear_205_97767)"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M2.5 9H21.5"
        stroke="url(#paint3_linear_205_97767)"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_205_97767"
          x1="12"
          y1="4"
          x2="12"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_205_97767"
          x1="7.5"
          y1="2.5"
          x2="7.5"
          y2="4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_205_97767"
          x1="17.5"
          y1="2.5"
          x2="17.5"
          y2="4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_205_97767"
          x1="12"
          y1="9"
          x2="12"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D8B65A" />
          <stop offset="0.9999" stop-color="#FFE395" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const OpcCoin = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 573 573"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5867_1787"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="573"
        height="573"
      >
        <rect width="572.58" height="572.58" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5867_1787)">
        <path
          d="M484.491 484.603C593.954 375.14 593.954 197.665 484.491 88.2017C375.028 -21.2615 197.553 -21.2615 88.0898 88.2017C-21.3734 197.665 -21.3734 375.14 88.0898 484.603C197.553 594.066 375.028 594.066 484.491 484.603Z"
          fill="#F7DE6A"
        />
        <path
          d="M462.4 462.511C559.662 365.249 559.662 207.556 462.4 110.294C365.138 13.0317 207.445 13.0317 110.183 110.294C12.9209 207.556 12.9209 365.249 110.183 462.511C207.445 559.773 365.138 559.773 462.4 462.511Z"
          fill="#CAAD51"
        />
        <path
          d="M286.315 535.338C423.865 535.338 535.372 423.831 535.372 286.28C535.372 148.729 423.865 37.2227 286.315 37.2227C148.764 37.2227 37.2573 148.729 37.2573 286.28C37.2573 423.831 148.764 535.338 286.315 535.338Z"
          fill="#B39949"
        />
        <path
          d="M454.087 469.792C551.349 372.53 551.349 214.837 454.087 117.575C356.825 20.313 199.132 20.313 101.87 117.575C4.60748 214.837 4.60752 372.53 101.87 469.792C199.132 567.054 356.825 567.054 454.087 469.792Z"
          fill="#CAAD51"
        />
        <path
          d="M286.31 494.855C401.5 494.855 494.88 401.476 494.88 286.286C494.88 171.096 401.5 77.7168 286.31 77.7168C171.121 77.7168 77.741 171.096 77.741 286.286C77.741 401.476 171.121 494.855 286.31 494.855Z"
          fill="url(#paint0_linear_5867_1787)"
        />
        <g filter="url(#filter0_d_5867_1787)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M299.61 148H273.361V329.354H299.61V148ZM197 329.355H374.775V412.873H197V329.355ZM218.475 350.829H353.297V391.395H218.475V350.829ZM262.623 183.198V152.176L200.581 187.373V217.798L262.623 183.198ZM262.623 202.885V233.906L200.581 268.507V238.082L262.623 202.885Z"
            fill="url(#paint1_linear_5867_1787)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5867_1787"
          x="172"
          y="123"
          width="227.775"
          height="314.873"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5867_1787"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5867_1787"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5867_1787"
          x1="168.44"
          y1="114.869"
          x2="404.138"
          y2="457.703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F5E5AF" />
          <stop offset="1" stop-color="#E2C25A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5867_1787"
          x1="254.791"
          y1="280.437"
          x2="316.933"
          y2="285.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ECD996" />
          <stop offset="0.475" stop-color="white" />
          <stop offset="1" stop-color="#ECD996" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LeftArrayIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.125 8.20898L13.875 19.0007L23.125 29.7923"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PercentageSign = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 7.3125C7.13875 7.3125 7.02999 7.27951 6.93749 7.2177C6.84499 7.15589 6.77289 7.06804 6.73032 6.96526C6.68774 6.86248 6.6766 6.74938 6.69831 6.64026C6.72001 6.53115 6.77359 6.43092 6.85225 6.35225C6.93092 6.27359 7.03115 6.22001 7.14026 6.19831C7.24938 6.1766 7.36248 6.18774 7.46526 6.23032C7.56804 6.27289 7.65589 6.34499 7.7177 6.43749C7.77951 6.52999 7.8125 6.63875 7.8125 6.75C7.8125 6.89918 7.75324 7.04226 7.64775 7.14775C7.54226 7.25324 7.39918 7.3125 7.25 7.3125ZM11.75 10.6875C11.6387 10.6875 11.53 10.7205 11.4375 10.7823C11.345 10.8441 11.2729 10.932 11.2303 11.0347C11.1877 11.1375 11.1766 11.2506 11.1983 11.3597C11.22 11.4689 11.2736 11.5691 11.3523 11.6477C11.4309 11.7264 11.5311 11.78 11.6403 11.8017C11.7494 11.8234 11.8625 11.8123 11.9653 11.7697C12.068 11.7271 12.1559 11.655 12.2177 11.5625C12.2795 11.47 12.3125 11.3613 12.3125 11.25C12.3125 11.1008 12.2532 10.9577 12.1477 10.8523C12.0423 10.7468 11.8992 10.6875 11.75 10.6875ZM17.375 9C17.375 9.73406 16.847 10.2846 16.3808 10.7705C16.1157 11.0475 15.8415 11.333 15.7381 11.584C15.6425 11.8139 15.6369 12.195 15.6312 12.5641C15.6207 13.2504 15.6095 14.028 15.0687 14.5687C14.528 15.1095 13.7504 15.1207 13.0641 15.1312C12.695 15.1369 12.3139 15.1425 12.084 15.2381C11.833 15.3415 11.5475 15.6157 11.2705 15.8808C10.7846 16.347 10.2341 16.875 9.5 16.875C8.76594 16.875 8.21539 16.347 7.72953 15.8808C7.4525 15.6157 7.16703 15.3415 6.91602 15.2381C6.68609 15.1425 6.305 15.1369 5.93586 15.1312C5.24961 15.1207 4.47195 15.1095 3.93125 14.5687C3.39055 14.028 3.3793 13.2504 3.36875 12.5641C3.36312 12.195 3.3575 11.8139 3.26187 11.584C3.15852 11.333 2.8843 11.0475 2.61922 10.7705C2.15305 10.2846 1.625 9.73406 1.625 9C1.625 8.26594 2.15305 7.71539 2.61922 7.22953C2.8843 6.9525 3.15852 6.66703 3.26187 6.41602C3.3575 6.18609 3.36312 5.805 3.36875 5.43586C3.3793 4.74961 3.39055 3.97195 3.93125 3.43125C4.47195 2.89055 5.24961 2.8793 5.93586 2.86875C6.305 2.86312 6.68609 2.8575 6.91602 2.76187C7.16703 2.65852 7.4525 2.3843 7.72953 2.11922C8.21539 1.65305 8.76594 1.125 9.5 1.125C10.2341 1.125 10.7846 1.65305 11.2705 2.11922C11.5475 2.3843 11.833 2.65852 12.084 2.76187C12.3139 2.8575 12.695 2.86312 13.0641 2.86875C13.7504 2.8793 14.528 2.89055 15.0687 3.43125C15.6095 3.97195 15.6207 4.74961 15.6312 5.43586C15.6369 5.805 15.6425 6.18609 15.7381 6.41602C15.8415 6.66703 16.1157 6.9525 16.3808 7.22953C16.847 7.71539 17.375 8.26594 17.375 9ZM7.25 8.4375C7.58376 8.4375 7.91002 8.33853 8.18752 8.1531C8.46503 7.96768 8.68132 7.70413 8.80905 7.39578C8.93677 7.08743 8.97019 6.74813 8.90508 6.42078C8.83996 6.09344 8.67924 5.79276 8.44324 5.55676C8.20724 5.32076 7.90656 5.16004 7.57922 5.09492C7.25187 5.02981 6.91257 5.06323 6.60422 5.19095C6.29587 5.31868 6.03232 5.53497 5.8469 5.81248C5.66147 6.08998 5.5625 6.41624 5.5625 6.75C5.5625 7.19755 5.74029 7.62678 6.05676 7.94324C6.37322 8.25971 6.80245 8.4375 7.25 8.4375ZM12.7105 6.58547C12.7627 6.53321 12.8042 6.47116 12.8325 6.40288C12.8608 6.3346 12.8753 6.26141 12.8753 6.1875C12.8753 6.11359 12.8608 6.0404 12.8325 5.97212C12.8042 5.90384 12.7627 5.84179 12.7105 5.78953C12.6582 5.73727 12.5962 5.69581 12.5279 5.66753C12.4596 5.63924 12.3864 5.62469 12.3125 5.62469C12.2386 5.62469 12.1654 5.63924 12.0971 5.66753C12.0288 5.69581 11.9668 5.73727 11.9145 5.78953L6.28953 11.4145C6.23727 11.4668 6.19581 11.5288 6.16753 11.5971C6.13924 11.6654 6.12469 11.7386 6.12469 11.8125C6.12469 11.8864 6.13924 11.9596 6.16753 12.0279C6.19581 12.0962 6.23727 12.1582 6.28953 12.2105C6.39508 12.316 6.53823 12.3753 6.6875 12.3753C6.76141 12.3753 6.8346 12.3608 6.90288 12.3325C6.97116 12.3042 7.03321 12.2627 7.08547 12.2105L12.7105 6.58547ZM13.4375 11.25C13.4375 10.9162 13.3385 10.59 13.1531 10.3125C12.9677 10.035 12.7041 9.81868 12.3958 9.69095C12.0874 9.56323 11.7481 9.52981 11.4208 9.59492C11.0934 9.66004 10.7928 9.82076 10.5568 10.0568C10.3208 10.2928 10.16 10.5934 10.0949 10.9208C10.0298 11.2481 10.0632 11.5874 10.191 11.8958C10.3187 12.2041 10.535 12.4677 10.8125 12.6531C11.09 12.8385 11.4162 12.9375 11.75 12.9375C12.1976 12.9375 12.6268 12.7597 12.9432 12.4432C13.2597 12.1268 13.4375 11.6976 13.4375 11.25Z"
        fill="#6EE755"
      />
    </svg>
  );
};

export const AlertSign = ({ width = 17, height = 15 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1498 12.2251L10.001 1.54677C9.8473 1.28515 9.62794 1.06823 9.36463 0.917511C9.10131 0.76679 8.80318 0.6875 8.49978 0.6875C8.19638 0.6875 7.89825 0.76679 7.63493 0.917511C7.37161 1.06823 7.15226 1.28515 6.99861 1.54677L0.849778 12.2251C0.701936 12.4782 0.624023 12.766 0.624023 13.059C0.624023 13.3521 0.701936 13.6399 0.849778 13.8929C1.00146 14.1561 1.22044 14.3742 1.48425 14.5249C1.74806 14.6755 2.04719 14.7532 2.35095 14.75H14.6486C14.9521 14.753 15.251 14.6751 15.5145 14.5245C15.778 14.3739 15.9968 14.1559 16.1484 13.8929C16.2964 13.64 16.3746 13.3523 16.3748 13.0592C16.3751 12.7662 16.2974 12.4783 16.1498 12.2251ZM7.93728 6.31255C7.93728 6.16336 7.99654 6.02029 8.10203 5.9148C8.20752 5.80931 8.35059 5.75005 8.49978 5.75005C8.64896 5.75005 8.79204 5.80931 8.89753 5.9148C9.00302 6.02029 9.06228 6.16336 9.06228 6.31255V9.12505C9.06228 9.27423 9.00302 9.41731 8.89753 9.52279C8.79204 9.62828 8.64896 9.68755 8.49978 9.68755C8.35059 9.68755 8.20752 9.62828 8.10203 9.52279C7.99654 9.41731 7.93728 9.27423 7.93728 9.12505V6.31255ZM8.49978 12.5C8.3329 12.5 8.16977 12.4506 8.03102 12.3578C7.89226 12.2651 7.78412 12.1334 7.72025 11.9792C7.65639 11.825 7.63968 11.6554 7.67224 11.4917C7.7048 11.328 7.78516 11.1777 7.90316 11.0597C8.02116 10.9417 8.1715 10.8613 8.33517 10.8288C8.49884 10.7962 8.66849 10.8129 8.82267 10.8768C8.97684 10.9406 9.10862 11.0488 9.20133 11.1875C9.29404 11.3263 9.34353 11.4894 9.34353 11.6563C9.34353 11.8801 9.25463 12.0947 9.0964 12.2529C8.93817 12.4112 8.72355 12.5 8.49978 12.5Z"
        fill="#ED6664"
      />
    </svg>
  );
};

export const LeftArrowIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L9 12L15 19"
        stroke="#090909"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ChartBar = ({ width = 18, height = 18 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 14.0625H15.1875V2.8125C15.1875 2.66332 15.1282 2.52024 15.0227 2.41475C14.9173 2.30926 14.7742 2.25 14.625 2.25H10.6875C10.5383 2.25 10.3952 2.30926 10.2898 2.41475C10.1843 2.52024 10.125 2.66332 10.125 2.8125V5.625H6.75C6.60082 5.625 6.45774 5.68426 6.35225 5.78975C6.24676 5.89524 6.1875 6.03832 6.1875 6.1875V9H3.375C3.22582 9 3.08274 9.05926 2.97725 9.16475C2.87176 9.27024 2.8125 9.41332 2.8125 9.5625V14.0625H2.25C2.10082 14.0625 1.95774 14.1218 1.85225 14.2273C1.74676 14.3327 1.6875 14.4758 1.6875 14.625C1.6875 14.7742 1.74676 14.9173 1.85225 15.0227C1.95774 15.1282 2.10082 15.1875 2.25 15.1875H15.75C15.8992 15.1875 16.0423 15.1282 16.1477 15.0227C16.2532 14.9173 16.3125 14.7742 16.3125 14.625C16.3125 14.4758 16.2532 14.3327 16.1477 14.2273C16.0423 14.1218 15.8992 14.0625 15.75 14.0625ZM11.25 3.375H14.0625V14.0625H11.25V3.375ZM7.3125 6.75H10.125V14.0625H7.3125V6.75ZM3.9375 10.125H6.1875V14.0625H3.9375V10.125Z"
        fill="#661EFF"
      />
    </svg>
  );
};

export const PinnedIcon = ({
  width = 18,
  height = 18,
  fillColor = "#343330",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1875 11.8125H14.5343L13.0458 3.375H13.5C13.6492 3.375 13.7923 3.31574 13.8977 3.21025C14.0032 3.10476 14.0625 2.96168 14.0625 2.8125C14.0625 2.66332 14.0032 2.52024 13.8977 2.41475C13.7923 2.30926 13.6492 2.25 13.5 2.25H4.5C4.35082 2.25 4.20774 2.30926 4.10225 2.41475C3.99676 2.52024 3.9375 2.66332 3.9375 2.8125C3.9375 2.96168 3.99676 3.10476 4.10225 3.21025C4.20774 3.31574 4.35082 3.375 4.5 3.375H4.95422L3.4657 11.8125H2.8125C2.66332 11.8125 2.52024 11.8718 2.41475 11.9773C2.30926 12.0827 2.25 12.2258 2.25 12.375C2.25 12.5242 2.30926 12.6673 2.41475 12.7727C2.52024 12.8782 2.66332 12.9375 2.8125 12.9375H8.4375V16.875C8.4375 17.0242 8.49676 17.1673 8.60225 17.2727C8.70774 17.3782 8.85082 17.4375 9 17.4375C9.14918 17.4375 9.29226 17.3782 9.39775 17.2727C9.50324 17.1673 9.5625 17.0242 9.5625 16.875V12.9375H15.1875C15.3367 12.9375 15.4798 12.8782 15.5852 12.7727C15.6907 12.6673 15.75 12.5242 15.75 12.375C15.75 12.2258 15.6907 12.0827 15.5852 11.9773C15.4798 11.8718 15.3367 11.8125 15.1875 11.8125ZM6.0968 3.375H11.9032L13.3917 11.8125H4.60828L6.0968 3.375Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const StockMarketIcon = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3125 14.625C16.3125 14.7742 16.2532 14.9173 16.1477 15.0227C16.0423 15.1282 15.8992 15.1875 15.75 15.1875H2.25C2.10082 15.1875 1.95774 15.1282 1.85225 15.0227C1.74676 14.9173 1.6875 14.7742 1.6875 14.625V3.375C1.6875 3.22582 1.74676 3.08274 1.85225 2.97725C1.95774 2.87176 2.10082 2.8125 2.25 2.8125C2.39918 2.8125 2.54226 2.87176 2.64775 2.97725C2.75324 3.08274 2.8125 3.22582 2.8125 3.375V10.0104L6.37945 6.89062C6.47652 6.80566 6.59983 6.75663 6.72874 6.75177C6.85765 6.74691 6.98431 6.7865 7.0875 6.86391L11.2226 9.96539L15.3795 6.32812C15.434 6.27417 15.4989 6.23194 15.5703 6.20401C15.6418 6.17608 15.7181 6.16306 15.7948 6.16573C15.8714 6.1684 15.9467 6.18672 16.016 6.21956C16.0853 6.2524 16.1472 6.29906 16.1978 6.35668C16.2484 6.4143 16.2867 6.48166 16.3103 6.55462C16.3339 6.62759 16.3424 6.70461 16.3352 6.78096C16.3279 6.85731 16.3052 6.93137 16.2683 6.99859C16.2313 7.06582 16.1811 7.12479 16.1205 7.17188L11.6205 11.1094C11.5235 11.1943 11.4002 11.2434 11.2713 11.2482C11.1424 11.2531 11.0157 11.2135 10.9125 11.1361L6.77742 8.03602L2.8125 11.5052V14.0625H15.75C15.8992 14.0625 16.0423 14.1218 16.1477 14.2273C16.2532 14.3327 16.3125 14.4758 16.3125 14.625Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const OtherExpensesIcon = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1875 4.5H3.9375C3.78832 4.5 3.64524 4.44074 3.53975 4.33525C3.43426 4.22976 3.375 4.08668 3.375 3.9375C3.375 3.78832 3.43426 3.64524 3.53975 3.53975C3.64524 3.43426 3.78832 3.375 3.9375 3.375H13.5C13.6492 3.375 13.7923 3.31574 13.8977 3.21025C14.0032 3.10476 14.0625 2.96168 14.0625 2.8125C14.0625 2.66332 14.0032 2.52024 13.8977 2.41475C13.7923 2.30926 13.6492 2.25 13.5 2.25H3.9375C3.48995 2.25 3.06072 2.42779 2.74426 2.74426C2.42779 3.06072 2.25 3.48995 2.25 3.9375V12.9375C2.25 13.3851 2.42779 13.8143 2.74426 14.1307C3.06072 14.4472 3.48995 14.625 3.9375 14.625H15.1875C15.4859 14.625 15.772 14.5065 15.983 14.2955C16.194 14.0845 16.3125 13.7984 16.3125 13.5V5.625C16.3125 5.32663 16.194 5.04048 15.983 4.8295C15.772 4.61853 15.4859 4.5 15.1875 4.5ZM15.1875 13.5H3.9375C3.78832 13.5 3.64524 13.4407 3.53975 13.3352C3.43426 13.2298 3.375 13.0867 3.375 12.9375V5.52867C3.55562 5.5927 3.74587 5.62528 3.9375 5.625H15.1875V13.5ZM11.8125 9.28125C11.8125 9.11437 11.862 8.95124 11.9547 8.81249C12.0474 8.67373 12.1792 8.56559 12.3334 8.50173C12.4875 8.43787 12.6572 8.42116 12.8209 8.45371C12.9845 8.48627 13.1349 8.56663 13.2529 8.68463C13.3709 8.80263 13.4512 8.95297 13.4838 9.11664C13.5163 9.28031 13.4996 9.44996 13.4358 9.60414C13.3719 9.75831 13.2638 9.89009 13.125 9.9828C12.9863 10.0755 12.8231 10.125 12.6562 10.125C12.4325 10.125 12.2179 10.0361 12.0596 9.87787C11.9014 9.71964 11.8125 9.50503 11.8125 9.28125Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const OtherInvestmentsIcon = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 8.15625C13.5 8.32313 13.4505 8.48626 13.3578 8.62501C13.2651 8.76377 13.1333 8.87191 12.9791 8.93577C12.825 8.99963 12.6553 9.01634 12.4916 8.98379C12.328 8.95123 12.1776 8.87087 12.0596 8.75287C11.9416 8.63487 11.8613 8.48453 11.8287 8.32086C11.7962 8.15719 11.8129 7.98754 11.8767 7.83336C11.9406 7.67919 12.0487 7.54741 12.1875 7.4547C12.3262 7.36198 12.4894 7.3125 12.6562 7.3125C12.88 7.3125 13.0946 7.40139 13.2529 7.55963C13.4111 7.71786 13.5 7.93247 13.5 8.15625ZM10.6875 4.5H7.875C7.72582 4.5 7.58274 4.55926 7.47725 4.66475C7.37176 4.77024 7.3125 4.91332 7.3125 5.0625C7.3125 5.21168 7.37176 5.35476 7.47725 5.46025C7.58274 5.56574 7.72582 5.625 7.875 5.625H10.6875C10.8367 5.625 10.9798 5.56574 11.0852 5.46025C11.1907 5.35476 11.25 5.21168 11.25 5.0625C11.25 4.91332 11.1907 4.77024 11.0852 4.66475C10.9798 4.55926 10.8367 4.5 10.6875 4.5ZM17.4375 7.875V10.125C17.4375 10.5726 17.2597 11.0018 16.9432 11.3182C16.6268 11.6347 16.1976 11.8125 15.75 11.8125H15.5841L14.4443 15.0033C14.3663 15.2218 14.2225 15.4109 14.0329 15.5446C13.8432 15.6783 13.6168 15.75 13.3847 15.75H12.4903C12.2582 15.75 12.0318 15.6783 11.8421 15.5446C11.6525 15.4109 11.5087 15.2218 11.4307 15.0033L11.2957 14.625H7.2668L7.1318 15.0033C7.05376 15.2218 6.91005 15.4109 6.72035 15.5446C6.53065 15.6783 6.30426 15.75 6.07219 15.75H5.17781C4.94574 15.75 4.71935 15.6783 4.52965 15.5446C4.33995 15.4109 4.19624 15.2218 4.1182 15.0033L3.23438 12.5311C2.39356 11.5795 1.86709 10.3915 1.72687 9.12937C1.54534 9.22472 1.39332 9.36787 1.28725 9.54335C1.18117 9.71882 1.12506 9.91995 1.125 10.125C1.125 10.2742 1.06574 10.4173 0.960248 10.5227C0.854758 10.6282 0.711684 10.6875 0.5625 10.6875C0.413316 10.6875 0.270242 10.6282 0.164752 10.5227C0.0592632 10.4173 0 10.2742 0 10.125C0.000859484 9.62337 0.169328 9.13641 0.478641 8.74148C0.787954 8.34656 1.22037 8.06633 1.70719 7.94531C1.83285 6.39515 2.53689 4.94894 3.67951 3.89385C4.82213 2.83877 6.31976 2.25197 7.875 2.25H15.1875C15.3367 2.25 15.4798 2.30926 15.5852 2.41475C15.6907 2.52024 15.75 2.66332 15.75 2.8125C15.75 2.96168 15.6907 3.10476 15.5852 3.21025C15.4798 3.31574 15.3367 3.375 15.1875 3.375H13.6835C14.617 4.02996 15.3512 4.93034 15.8048 5.97656C15.8351 6.04688 15.8646 6.11719 15.8927 6.1875C16.3151 6.22335 16.7085 6.41685 16.9947 6.72951C17.281 7.04218 17.439 7.45111 17.4375 7.875ZM16.3125 7.875C16.3125 7.72582 16.2532 7.58274 16.1477 7.47725C16.0423 7.37176 15.8992 7.3125 15.75 7.3125H15.4927C15.3729 7.31263 15.2561 7.2745 15.1595 7.20368C15.0629 7.13285 14.9914 7.03303 14.9555 6.91875C14.6332 5.89031 13.9907 4.99178 13.1217 4.35428C12.2527 3.71677 11.2027 3.37365 10.125 3.375H7.875C6.89254 3.37495 5.93128 3.66077 5.10846 4.19762C4.28564 4.73446 3.6368 5.49912 3.24107 6.39837C2.84534 7.29761 2.71982 8.29257 2.87981 9.26192C3.03981 10.2313 3.4784 11.1331 4.14211 11.8575C4.19286 11.9127 4.23207 11.9775 4.25742 12.048L5.17781 14.625H6.07219L6.34078 13.8734C6.37978 13.7641 6.45158 13.6696 6.54636 13.6028C6.64114 13.536 6.75426 13.5001 6.87023 13.5H11.6923C11.8082 13.5001 11.9214 13.536 12.0161 13.6028C12.1109 13.6696 12.1827 13.7641 12.2217 13.8734L12.4903 14.625H13.3847L14.658 11.0609C14.697 10.9516 14.7688 10.8571 14.8636 10.7903C14.9584 10.7235 15.0715 10.6876 15.1875 10.6875H15.75C15.8992 10.6875 16.0423 10.6282 16.1477 10.5227C16.2532 10.4173 16.3125 10.2742 16.3125 10.125V7.875Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const VehicleIcon = ({
  width = 18,
  height = 18,
  fillColor = "#1640C1",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 7.3125H16.1156L14.1623 2.91797C14.0739 2.71914 13.9298 2.55022 13.7473 2.43166C13.5649 2.31311 13.352 2.25 13.1344 2.25H4.86562C4.64804 2.25 4.43512 2.31311 4.25266 2.43166C4.07021 2.55022 3.92605 2.71914 3.83766 2.91797L1.88437 7.3125H1.125C0.975816 7.3125 0.832742 7.37176 0.727252 7.47725C0.621763 7.58274 0.5625 7.72582 0.5625 7.875C0.5625 8.02418 0.621763 8.16726 0.727252 8.27275C0.832742 8.37824 0.975816 8.4375 1.125 8.4375H1.6875V14.0625C1.6875 14.3609 1.80603 14.647 2.017 14.858C2.22798 15.069 2.51413 15.1875 2.8125 15.1875H4.5C4.79837 15.1875 5.08452 15.069 5.2955 14.858C5.50647 14.647 5.625 14.3609 5.625 14.0625V12.9375H12.375V14.0625C12.375 14.3609 12.4935 14.647 12.7045 14.858C12.9155 15.069 13.2016 15.1875 13.5 15.1875H15.1875C15.4859 15.1875 15.772 15.069 15.983 14.858C16.194 14.647 16.3125 14.3609 16.3125 14.0625V8.4375H16.875C17.0242 8.4375 17.1673 8.37824 17.2727 8.27275C17.3782 8.16726 17.4375 8.02418 17.4375 7.875C17.4375 7.72582 17.3782 7.58274 17.2727 7.47725C17.1673 7.37176 17.0242 7.3125 16.875 7.3125ZM4.86562 3.375H13.1344L14.8845 7.3125H3.11555L4.86562 3.375ZM15.1875 14.0625H13.5V12.375C13.5 12.2258 13.4407 12.0827 13.3352 11.9773C13.2298 11.8718 13.0867 11.8125 12.9375 11.8125H5.0625C4.91332 11.8125 4.77024 11.8718 4.66475 11.9773C4.55926 12.0827 4.5 12.2258 4.5 12.375V14.0625H2.8125V8.4375H15.1875V14.0625Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TaxIcon = ({ width = 18, height = 18, fillColor = "#1640C1" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5955 4.48875C13.1379 3.76031 11.2029 3.375 9 3.375C6.79711 3.375 4.86211 3.76031 3.40453 4.48875C1.94695 5.21719 1.125 6.24234 1.125 7.3125V10.6875C1.125 11.7577 1.95609 12.7863 3.40453 13.5113C4.85297 14.2362 6.79711 14.625 9 14.625C11.2029 14.625 13.1379 14.2397 14.5955 13.5113C16.053 12.7828 16.875 11.7577 16.875 10.6875V7.3125C16.875 6.24234 16.0439 5.21367 14.5955 4.48875ZM9 4.5C13.4044 4.5 15.75 6.13336 15.75 7.3125C15.75 8.49164 13.4044 10.125 9 10.125C4.59562 10.125 2.25 8.49164 2.25 7.3125C2.25 6.13336 4.59562 4.5 9 4.5ZM8.4375 11.2402V13.4902C7.10156 13.4466 5.97656 13.2497 5.0625 12.9635V10.7613C6.16439 11.0549 7.29744 11.2156 8.4375 11.2402ZM9.5625 11.2402C10.7026 11.2156 11.8356 11.0549 12.9375 10.7613V12.9628C12.0234 13.249 10.8984 13.4459 9.5625 13.4895V11.2402ZM2.25 10.6875V9.38883C2.60399 9.68267 2.99153 9.93356 3.40453 10.1363C3.57539 10.2213 3.75609 10.3015 3.9375 10.3774V12.5156C2.82445 11.9644 2.25 11.2704 2.25 10.6875ZM14.0625 12.5156V10.3774C14.246 10.3015 14.4246 10.2213 14.5955 10.1363C15.0085 9.93356 15.396 9.68267 15.75 9.38883V10.6875C15.75 11.2704 15.1755 11.9644 14.0625 12.5156Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const NewFeatureIcon = ({
  width = 18,
  height = 18,
  fillColor = "#227D12",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7037_88925)">
        <rect
          x="10.0804"
          y="1.97769"
          width="1.8432"
          height="12.5338"
          rx="0.803509"
          transform="rotate(-15 10.0804 1.97769)"
          stroke={fillColor}
        />
        <rect
          x="0.919222"
          y="7.61197"
          width="3.19489"
          height="6.51265"
          rx="0.803509"
          transform="rotate(-15 0.919222 7.61197)"
          stroke={fillColor}
        />
        <path d="M4.06902 7.63221L10.683 3.27961" stroke={fillColor} />
        <path d="M5.72365 12.1296L13.1641 12.5381" stroke={fillColor} />
        <path
          d="M6.61258 11.8905C6.67709 12.5006 6.97681 13.7484 7.65957 13.8592C7.94554 13.9294 8.40149 13.997 8.59372 14.022C8.88284 14.0596 9.82344 13.6925 9.35749 12.3026"
          stroke={fillColor}
        />
        <path
          d="M15.0211 5.10498L15.8912 3.59807"
          stroke={fillColor}
          stroke-linecap="round"
        />
        <path
          d="M16.0538 8.95901L17.5608 9.82903"
          stroke={fillColor}
          stroke-linecap="round"
        />
        <path
          d="M15.5653 6.73004L17.1385 6.3085"
          stroke={fillColor}
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7037_88925">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MemesIcon = ({
  width = 18,
  height = 18,
  fillColor = "#CCA300",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.6875C7.55372 1.6875 6.13993 2.11637 4.93739 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54585 9.00811 1.82801 10.4266C2.11016 11.8451 2.80661 13.148 3.82928 14.1707C4.85195 15.1934 6.15492 15.8898 7.5734 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM9 15.1875C7.77623 15.1875 6.57994 14.8246 5.56241 14.1447C4.54488 13.4648 3.75181 12.4985 3.2835 11.3679C2.81518 10.2372 2.69265 8.99314 2.93139 7.79288C3.17014 6.59262 3.75944 5.49011 4.62478 4.62478C5.49011 3.75944 6.59262 3.17014 7.79288 2.93139C8.99314 2.69264 10.2372 2.81518 11.3679 3.2835C12.4985 3.75181 13.4648 4.54488 14.1447 5.56241C14.8246 6.57994 15.1875 7.77623 15.1875 9C15.1856 10.6405 14.5331 12.2132 13.3732 13.3732C12.2132 14.5331 10.6405 15.1856 9 15.1875ZM5.625 7.59375C5.625 7.42687 5.67449 7.26374 5.7672 7.12499C5.85991 6.98623 5.99169 6.87809 6.14586 6.81423C6.30004 6.75037 6.46969 6.73366 6.63336 6.76621C6.79703 6.79877 6.94737 6.87913 7.06537 6.99713C7.18337 7.11513 7.26373 7.26547 7.29629 7.42914C7.32884 7.59281 7.31214 7.76246 7.24827 7.91664C7.18441 8.07081 7.07627 8.20259 6.93751 8.2953C6.79876 8.38802 6.63563 8.4375 6.46875 8.4375C6.24497 8.4375 6.03036 8.34861 5.87213 8.19037C5.7139 8.03214 5.625 7.81753 5.625 7.59375ZM12.375 7.59375C12.375 7.76063 12.3255 7.92376 12.2328 8.06251C12.1401 8.20127 12.0083 8.30941 11.8541 8.37327C11.7 8.43713 11.5303 8.45384 11.3666 8.42129C11.203 8.38873 11.0526 8.30837 10.9346 8.19037C10.8166 8.07237 10.7363 7.92203 10.7037 7.75836C10.6712 7.59469 10.6879 7.42504 10.7517 7.27086C10.8156 7.11669 10.9237 6.98491 11.0625 6.8922C11.2012 6.79948 11.3644 6.75 11.5312 6.75C11.755 6.75 11.9696 6.83889 12.1279 6.99713C12.2861 7.15536 12.375 7.36997 12.375 7.59375ZM12.2998 10.9688C11.5763 12.2196 10.3732 12.9375 9 12.9375C7.6268 12.9375 6.42445 12.2203 5.70094 10.9688C5.66024 10.9047 5.63291 10.8331 5.6206 10.7583C5.60829 10.6834 5.61124 10.6068 5.62929 10.5332C5.64734 10.4595 5.68011 10.3902 5.72562 10.3295C5.77114 10.2688 5.82846 10.218 5.89414 10.18C5.95982 10.142 6.0325 10.1177 6.10781 10.1086C6.18312 10.0994 6.25951 10.1056 6.33237 10.1268C6.40522 10.1479 6.47306 10.1836 6.53178 10.2316C6.5905 10.2796 6.6389 10.339 6.67406 10.4062C7.1993 11.314 8.02477 11.8125 9 11.8125C9.97523 11.8125 10.8007 11.3133 11.3252 10.4062C11.3998 10.277 11.5227 10.1827 11.6668 10.1441C11.811 10.1054 11.9645 10.1256 12.0938 10.2002C12.223 10.2748 12.3173 10.3977 12.3559 10.5418C12.3946 10.6859 12.3744 10.8395 12.2998 10.9688Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ContestIcon = ({
  width = 18,
  height = 18,
  fillColor = "#EE4D37",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3125 4.5H14.625V3.375C14.625 3.22582 14.5657 3.08274 14.4602 2.97725C14.3548 2.87176 14.2117 2.8125 14.0625 2.8125H3.9375C3.78832 2.8125 3.64524 2.87176 3.53975 2.97725C3.43426 3.08274 3.375 3.22582 3.375 3.375V4.5H1.6875C1.38913 4.5 1.10298 4.61853 0.892005 4.8295C0.681026 5.04048 0.5625 5.32663 0.5625 5.625V6.75C0.5625 7.49592 0.858816 8.21129 1.38626 8.73874C1.64743 8.9999 1.95747 9.20707 2.2987 9.34841C2.63993 9.48975 3.00566 9.5625 3.375 9.5625H3.63164C3.96299 10.6126 4.59476 11.5425 5.44887 12.2374C6.30298 12.9323 7.342 13.3617 8.4375 13.4726V15.1875H6.75C6.60082 15.1875 6.45774 15.2468 6.35225 15.3523C6.24676 15.4577 6.1875 15.6008 6.1875 15.75C6.1875 15.8992 6.24676 16.0423 6.35225 16.1477C6.45774 16.2532 6.60082 16.3125 6.75 16.3125H11.25C11.3992 16.3125 11.5423 16.2532 11.6477 16.1477C11.7532 16.0423 11.8125 15.8992 11.8125 15.75C11.8125 15.6008 11.7532 15.4577 11.6477 15.3523C11.5423 15.2468 11.3992 15.1875 11.25 15.1875H9.5625V13.4705C11.8083 13.2434 13.6716 11.6677 14.3494 9.5625H14.625C15.3709 9.5625 16.0863 9.26618 16.6137 8.73874C17.1412 8.21129 17.4375 7.49592 17.4375 6.75V5.625C17.4375 5.32663 17.319 5.04048 17.108 4.8295C16.897 4.61853 16.6109 4.5 16.3125 4.5ZM3.375 8.4375C2.92745 8.4375 2.49822 8.25971 2.18176 7.94324C1.86529 7.62678 1.6875 7.19755 1.6875 6.75V5.625H3.375V7.875C3.375 8.0625 3.38414 8.25 3.40242 8.4375H3.375ZM13.5 7.81172C13.5 10.3092 11.4609 12.3567 9 12.375C7.80653 12.375 6.66193 11.9009 5.81802 11.057C4.97411 10.2131 4.5 9.06847 4.5 7.875V3.9375H13.5V7.81172ZM16.3125 6.75C16.3125 7.19755 16.1347 7.62678 15.8182 7.94324C15.5018 8.25971 15.0726 8.4375 14.625 8.4375H14.5898C14.6129 8.2297 14.6247 8.0208 14.625 7.81172V5.625H16.3125V6.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CommunityUpdatesIcon = ({
  width = 18,
  height = 18,
  fillColor = "#0B59AD",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8355 9.39797L16.148 11.0855C16.0957 11.1378 16.0337 11.1793 15.9654 11.2076C15.8971 11.2359 15.8239 11.2504 15.75 11.2504C15.6761 11.2504 15.6029 11.2359 15.5346 11.2076C15.4663 11.1793 15.4043 11.1378 15.352 11.0855L13.6645 9.39797C13.559 9.29242 13.4997 9.14927 13.4997 9C13.4997 8.85073 13.559 8.70758 13.6645 8.60203C13.7701 8.49648 13.9132 8.43719 14.0625 8.43719C14.2118 8.43719 14.3549 8.49648 14.4605 8.60203L15.1875 9.32977V9C15.1881 7.68982 14.7729 6.41325 14.0015 5.35419C13.2302 4.29513 12.1426 3.50825 10.8954 3.10691C9.64821 2.70556 8.30581 2.71047 7.06158 3.12092C5.81735 3.53138 4.73553 4.32619 3.97195 5.39086C3.88487 5.51207 3.7532 5.59373 3.60591 5.61786C3.45862 5.64199 3.30777 5.60662 3.18656 5.51953C3.06535 5.43245 2.9837 5.30078 2.95957 5.15349C2.93544 5.0062 2.9708 4.85535 3.05789 4.73414C3.96034 3.47591 5.2389 2.53663 6.70938 2.05159C8.17985 1.56656 9.76634 1.56081 11.2403 2.03519C12.7142 2.50956 13.9996 3.43957 14.9111 4.69123C15.8226 5.94289 16.3133 7.4516 16.3125 9V9.32977L17.0395 8.60203C17.1451 8.49648 17.2882 8.43719 17.4375 8.43719C17.5868 8.43719 17.7299 8.49649 17.8355 8.60203C17.941 8.70758 18.0003 8.85073 18.0003 9C18.0003 9.14927 17.941 9.29242 17.8355 9.39797ZM14.94 13.2652C14.0373 14.5224 12.7589 15.4609 11.2889 15.9453C9.81891 16.4298 8.23308 16.4354 6.75973 15.9612C5.28637 15.487 4.00146 14.5575 3.08998 13.3066C2.17849 12.0557 1.68744 10.5478 1.6875 9V8.67024L0.960469 9.39797C0.854921 9.50352 0.711767 9.56281 0.5625 9.56281C0.413233 9.56281 0.270079 9.50352 0.164531 9.39797C0.0589834 9.29242 -0.000312805 9.14927 -0.000312805 9C-0.000312805 8.85073 0.0589834 8.70758 0.164531 8.60203L1.85203 6.91453C1.90427 6.86223 1.96631 6.82074 2.0346 6.79244C2.10288 6.76413 2.17608 6.74956 2.25 6.74956C2.32392 6.74956 2.39712 6.76413 2.4654 6.79244C2.53369 6.82074 2.59573 6.86223 2.64797 6.91453L4.33547 8.60203C4.44102 8.70758 4.50031 8.85073 4.50031 9C4.50031 9.14927 4.44102 9.29242 4.33547 9.39797C4.22992 9.50352 4.08677 9.56281 3.9375 9.56281C3.78823 9.56281 3.64508 9.50352 3.53953 9.39797L2.8125 8.67024V9C2.81117 10.5147 3.36786 11.9767 4.37625 13.107C5.0036 12.1979 5.88573 11.4946 6.91172 11.0855C6.3606 10.6514 5.95844 10.0564 5.76118 9.38313C5.56391 8.7099 5.58134 7.99193 5.81104 7.32906C6.04074 6.66619 6.47129 6.09137 7.04282 5.68455C7.61436 5.27772 8.29846 5.05911 9 5.05911C9.70154 5.05911 10.3856 5.27772 10.9572 5.68455C11.5287 6.09137 11.9593 6.66619 12.189 7.32906C12.4187 7.99193 12.4361 8.7099 12.2388 9.38313C12.0416 10.0564 11.6394 10.6514 11.0883 11.0855C12.1152 11.4946 12.998 12.1988 13.6252 13.1091C13.7674 12.9493 13.9014 12.7825 14.0266 12.6091C14.1137 12.4879 14.2454 12.4063 14.3927 12.3821C14.54 12.358 14.6908 12.3934 14.812 12.4805C14.9332 12.5676 15.0149 12.6992 15.039 12.8465C15.0632 12.9938 15.0278 13.1446 14.9407 13.2659L14.94 13.2652ZM9 10.6875C9.44501 10.6875 9.88002 10.5555 10.25 10.3083C10.62 10.0611 10.9084 9.70967 11.0787 9.29854C11.249 8.8874 11.2936 8.43501 11.2068 7.99855C11.12 7.56209 10.9057 7.16118 10.591 6.84651C10.2763 6.53184 9.87541 6.31755 9.43895 6.23073C9.0025 6.14392 8.5501 6.18847 8.13896 6.35877C7.72783 6.52907 7.37643 6.81746 7.12919 7.18747C6.88196 7.55748 6.75 7.99249 6.75 8.4375C6.75 9.03424 6.98705 9.60653 7.40901 10.0285C7.83097 10.4504 8.40326 10.6875 9 10.6875ZM9 15.1875C10.3728 15.1857 11.7062 14.7285 12.7913 13.8874C12.3843 13.251 11.8237 12.7273 11.1612 12.3645C10.4986 12.0017 9.75538 11.8116 9 11.8116C8.24462 11.8116 7.50139 12.0017 6.83882 12.3645C6.17625 12.7273 5.61567 13.251 5.20875 13.8874C6.29214 14.7315 7.62663 15.1891 9 15.1875Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const OPCExperienceIcon = ({
  width = 18,
  height = 18,
  fillColor = "#F17726",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83914 3.70055C7.70703 3.56878 7.54385 3.47241 7.36468 3.42034C7.1855 3.36826 6.99609 3.36215 6.81393 3.40258C6.63177 3.443 6.46273 3.52866 6.3224 3.65164C6.18208 3.77462 6.07499 3.93097 6.01102 4.10625L2.32031 14.258C2.25968 14.4254 2.2401 14.6049 2.2632 14.7814C2.28631 14.958 2.35143 15.1264 2.4531 15.2726C2.55477 15.4187 2.69002 15.5384 2.84749 15.6214C3.00497 15.7045 3.18008 15.7486 3.35812 15.75C3.48921 15.7491 3.61914 15.7253 3.74203 15.6797L13.893 11.9883C14.0684 11.9244 14.2248 11.8174 14.3479 11.6771C14.4709 11.5368 14.5567 11.3677 14.5971 11.1856C14.6376 11.0034 14.6316 10.814 14.5796 10.6348C14.5275 10.4555 14.4312 10.2923 14.2995 10.1602L7.83914 3.70055ZM7.25344 13.2075L4.7925 10.7466L5.71781 8.20055L9.79945 12.2822L7.25344 13.2075ZM3.38625 14.6137L4.37062 11.913L6.08977 13.6322L3.38625 14.6137ZM10.9688 11.8575L6.1425 7.03125L7.05656 4.50914L13.4852 10.9378L10.9688 11.8575ZM11.25 5.0625C11.2606 4.68223 11.3526 4.30866 11.52 3.96703C11.8927 3.22242 12.5958 2.8125 13.5 2.8125C13.9711 2.8125 14.2734 2.65148 14.4598 2.30555C14.5579 2.11201 14.6142 1.9 14.625 1.68328C14.6256 1.5341 14.6854 1.39125 14.7912 1.28615C14.8971 1.18106 15.0404 1.12233 15.1896 1.12289C15.3388 1.12345 15.4816 1.18325 15.5867 1.28913C15.6918 1.39502 15.7506 1.53832 15.75 1.6875C15.75 2.59172 15.1509 3.9375 13.5 3.9375C13.0289 3.9375 12.7266 4.09852 12.5402 4.44445C12.4421 4.63799 12.3858 4.85 12.375 5.06672C12.3747 5.14059 12.3599 5.21368 12.3314 5.28182C12.3029 5.34996 12.2612 5.41181 12.2088 5.46385C12.1563 5.51589 12.0942 5.55709 12.0258 5.5851C11.9575 5.61311 11.8843 5.62739 11.8104 5.62711C11.7365 5.62683 11.6634 5.61201 11.5953 5.58348C11.5272 5.55496 11.4653 5.51329 11.4133 5.46087C11.3612 5.40844 11.32 5.34627 11.292 5.27792C11.264 5.20957 11.2497 5.13637 11.25 5.0625ZM9.5625 2.8125V1.125C9.5625 0.975816 9.62176 0.832742 9.72725 0.727252C9.83274 0.621763 9.97582 0.5625 10.125 0.5625C10.2742 0.5625 10.4173 0.621763 10.5227 0.727252C10.6282 0.832742 10.6875 0.975816 10.6875 1.125V2.8125C10.6875 2.96168 10.6282 3.10476 10.5227 3.21025C10.4173 3.31574 10.2742 3.375 10.125 3.375C9.97582 3.375 9.83274 3.31574 9.72725 3.21025C9.62176 3.10476 9.5625 2.96168 9.5625 2.8125ZM16.7105 8.60203C16.7627 8.65429 16.8041 8.71633 16.8323 8.78459C16.8606 8.85286 16.8751 8.92602 16.8751 8.9999C16.875 9.07377 16.8604 9.14692 16.8321 9.21516C16.8038 9.2834 16.7624 9.3454 16.7101 9.39762C16.6579 9.44983 16.5958 9.49124 16.5276 9.51948C16.4593 9.54773 16.3861 9.56225 16.3123 9.56221C16.2384 9.56218 16.1652 9.5476 16.097 9.51929C16.0287 9.49099 15.9667 9.44953 15.9145 9.39727L14.7895 8.27227C14.684 8.16672 14.6247 8.02356 14.6247 7.8743C14.6247 7.72503 14.684 7.58188 14.7895 7.47633C14.8951 7.37078 15.0382 7.31148 15.1875 7.31148C15.3368 7.31148 15.4799 7.37078 15.5855 7.47633L16.7105 8.60203ZM17.0529 5.59617L15.3654 6.15867C15.2239 6.20585 15.0694 6.19487 14.9359 6.12815C14.8025 6.06143 14.701 5.94443 14.6538 5.80289C14.6066 5.66135 14.6176 5.50687 14.6844 5.37343C14.7511 5.23998 14.8681 5.13851 15.0096 5.09133L16.6971 4.52883C16.8386 4.48165 16.9931 4.49263 17.1266 4.55935C17.26 4.62607 17.3615 4.74307 17.4087 4.88461C17.4559 5.02615 17.4449 5.18063 17.3782 5.31407C17.3114 5.44752 17.1944 5.54899 17.0529 5.59617Z"
        fill={fillColor}
      />
    </svg>
  );
};
